import { BackPage } from "./backPage";
import { ButtonLink } from "./buttonLink";

export function ViewLinks({ components, backPage }) {
  return (
    <div className="flex flex-col gap-2 px-2 mt-6 pb-8">
      {components.map((item, idx) => (
        <div key={idx} className="flex flex-col bg-white border border-border items-center justify-between rounded-md p-4">
          <div className="pb-4 px-2">
            <p className="leading-relaxed">{item.helpText}</p>
          </div>
          <ButtonLink href={item.href}>{item.label}</ButtonLink>
        </div>
      ))}
      <BackPage href={backPage} />
    </div>
  )
}